<template>
  <div>
    <div class="mr-b25">
      <div class="title-bar title-h4 dot-title">기본정보</div>
      <el-form :model="formData" :rules="formRules" ref="basicInfoForm">
        <el-form-item prop="ipGroupName" label="IP그룹명">
          <el-input v-model="formData.ipGroupName" placeholder="입력해주세요."></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ipVersion" label="IP버전">
              <el-select v-model="formData.ipVersion" style="width:100%" @change="onIpVersionChange">
                <el-option v-for="version in [{ label: 'IPv4', value: 4 }, { label: 'IPv6', value: 6 }]" :key="version.value" :label="version.label" :value="version.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="orderbyIndex" label="정렬순서">
              <el-input-number v-model="formData.orderbyIndex" style="width:100%" controls-position="right" :min="1" :max="999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item prop="ipGroupDesc" label="설명">
          <el-input v-model="formData.ipGroupDesc" type="textarea" :rows="3" placeholder="입력해주세요."></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="title-bar title-h4 dot-title">IP 추가</div>
      <el-row class="title-bar">
        IP 목록
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="showAddIpaddressView"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="deleteIpaddress"><i class="fas fa-minus"></i></el-button>
        </div>
      </el-row>
      <el-table-wrapper max-height="220" :data="ipList" :columns="tableColumns" :column-default="columnDefault" :pagination="false" :show-search-tool="false" header-align="center" :show-custom-header="false" ref="ipTable"></el-table-wrapper>
    </div>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { cloneDeep, isEmpty, isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';

export default {
  name: 'WBasicInfoSettingView',
  props: {
    viewParams: Object,
  },
  data() {
    return {
      showHeaderSearchTool: false,
      columnDefault,
      oldFormData: {},
      formData: {
        ipGroupName: '',
        ipVersion: 4,
        orderbyIndex: 1,
        ipGroupDesc: '',
      },
      formRules: {
        ipGroupName: {
          required: true,
          message: '값을 입력해주세요',
          trigger: 'change',
        },
        ipVersion: {
          required: true,
          message: '값을 입력해주세요',
          trigger: 'change',
        },
        orderbyIndex: {
          required: true,
          message: '순서를 입력해주세요',
          trigger: 'change',
        },
      },
      tableColumns: [
        { type: 'selection' },
        { prop: 'netIpaddress', label: 'IP주소', searchable: true, width: 250 },
        { prop: 'hostName', label: '호스트명', searchable: true, formatter: this.getEmptyText },
      ],
      ipList: [],
      oldIpStrList: [],
    };
  },
  watch: {
    'viewParams.ipList': {
      handler(list) {
        this.ipList = cloneDeep(list);
      },
      immediate: true,
    },
    'viewParams.orderbyIndex': {
      handler(index) {
        this.formData.orderbyIndex = index;
      },
      immediate: true,
    },
    'viewParams.selectedRecord': {
      handler(record) {
        if (!isEmpty(record)) {
          this.formData = {
            ipGroupName: record.ipGroupName,
            ipVersion: Number(record.ipVersion),
            orderbyIndex: record.orderbyIndex,
            ipGroupDesc: record.ipGroupDesc,
          };
          this.oldFormData = cloneDeep(this.formData);
          this.oldIpStrList = record.ipList.map((ip) => ip.netIpaddress); // 수정 이전 ip주소 string배열로 저장
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * IP그룹 추가/수정에 필요한 정보 가공
     * @author jeee12
     */
    getIpGroupBasicInfo() {
      const validate = this.$refs.basicInfoForm.validate;
      let basicInfo = {};

      if (isEmpty(this.viewParams.selectedRecord)) {
        // ip그룹 추가 파라미터 가공
        basicInfo = Object.assign(this.formData, { ipList: this.viewParams.ipList });
      } else {
        // ip그룹 수정 파라미터 가공
        let isInfoChanged = false;
        let isIpListChanged = false;
        const formData = {
          ipGroupId: this.viewParams.selectedRecord.ipGroupId,
          isGroupDirty: false, // ip그룹 기본정보 수정여부 서버호출 파라미터로 전달
        };

        Object.keys(this.formData).forEach((key) => {
          if (this.oldFormData[key] !== this.formData[key]) {
            isInfoChanged = true;
            formData.isGroupDirty = true;
            formData[key] = this.formData[key];
          }
        });

        if (this.ipList.length !== this.oldIpStrList.length) {
          isIpListChanged = true;
        } else {
          this.ipList.forEach((ip) => {
            if (this.oldIpStrList.indexOf(ip.netIpaddress) === -1) {
              isIpListChanged = true;
            }
          });
        }

        if (isIpListChanged) { // ip그룹의 ip목록 수정여부
          basicInfo = Object.assign(formData, { ipList: this.viewParams.ipList });
        } else if (isInfoChanged) { // ip그룹 기본정보 수정여부
          basicInfo = cloneDeep(formData);
        }
      }

      return {
        validate, // Promise
        basicInfo,
      };
    },
    /**
     * IP추가 화면으로 전환
     * @author jeee12
     * @return {[type]} [description]
     */
    showAddIpaddressView() {
      this.$emit('change-view', 'addIpaddressView', this.formData.ipVersion);
    },
    /**
     * IP추가 테이블에서 선택한 IP주소 삭제
     * @author jeee12
     * @return {[type]} [description]
     */
    deleteIpaddress() {
      const selection = this.$refs.ipTable.$children[0].selection;
      const ipList = selection.map((ip) => ip.netIpaddress);

      if (ipList.length === 0) {
        this.$message(msgUtil.getCustomMsgData('대상을 선택해주세요.'));
        return;
      }

      this.$confirm('삭제하시겠습니까?', '확인', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then(() => {
        this.ipList = this.ipList.filter((ip) => ipList.indexOf(ip.netIpaddress) === -1);
        this.$emit('delete-ip', this.ipList);
      }).catch(() => {});
    },
    /**
     * IP버전 select change (IP목록 초기화)
     * @author jeee12
     * @return {[type]} [description]
     */
    onIpVersionChange() {
      this.ipList = [];
      this.$emit('delete-ip', this.ipList);
    },
    /**
     * 테이블 데이터 빈 값 체크
     * @author jeee12
     */
    getEmptyText(row, column, value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    /**
     * 폼 데이터 초기화
     * @author jeee12
     * @return {[type]} [description]
     */
    initData() {
      this.formData = {
        ipGroupName: '',
        ipVersion: 4,
        orderbyIndex: this.viewParams.orderbyIndex,
        ipGroupDesc: '',
      };

      this.$nextTick(() => {
        this.$refs.basicInfoForm.clearValidate();
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/IpGroupSettings/components/BasicInfoSettingView.vue